/*
 * @Description: 设置页面参数
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-21 14:57:27
 * @LastEditTime: 2019-09-20 14:46:33
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './setPage.css';
import Link from '../../../components/Link'
import router from '../router';
import { getContentNum, getBrandIndustry } from '../../../controller';
import { getSessionQuery } from '../../../utils';
import BrandInput from '../../../components/BrandInput/BrandInput';
import TimeInput from '../../../components/TimeInput/TimeInput';

class SetPage extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      firstPage: Object.keys(router)[1],
      brand: '',
      tempIndustry: {},
      industry: '',
      industryList: [],
      beginTime: '',
      endTime: '',
      competingGoods: [],

      isCustom: '0',
      tempBrandName: '',
      btnDisabled: true
    }

    this.setPage = this.setPage.bind(this);
  }

  componentDidMount () {
    this.initData();
  }

  componentWillUpdate (nextProps, nextState) {
    const {tempIndustry, competingGoods} = this.state
    if (tempIndustry !== nextState.tempIndustry) {
      this.setState({
        industryList: this.getIndustryIntersection([nextState.tempIndustry].concat(competingGoods))
      })
    }
  }

  /**
   * 从sessionStorage中读取历史参数
   * @memberof SetPage
   */
  initData () {
    const data = getSessionQuery('query');
    this.setState({
      ...data,
    })

    this.setBrand(data.brand)
  }

  /**
   * 设置品牌id
   * @param {*} query
   * @memberof SetPage
   */
  getContentNum (query) {
    getContentNum({
      brandName: query.brandName,
      statisDate: query.statisDate,
      startDate: query.beginTime
    })
      .then(res => {
        // @ts-ignore
        global.brandId = res.brandId;
        sessionStorage.setItem('somedata', JSON.stringify(res));
      })
  }

  /**
   * 设置页面参数并存储到sessionStorage
   * @memberof SetPage
   */
  setPage () {    
    const {brand, industry, beginTime, endTime, competingGoods, isCustom} = this.state;
    sessionStorage.setItem('query', JSON.stringify({
      brand, industry, beginTime, endTime, competingGoods, isCustom
    }));

    this.getContentNum({
      brandName: brand,
      statisDate: endTime,
      beginTime: beginTime
    })
  }

  /**
   * 添加竞品
   * @memberof SetPage
   */
  addCompetingGoods = () => {
    
    const {tempBrandName, btnDisabled, tempIndustry} = this.state
    // 避免连续点击
    // 避免添加空数据
    if (!btnDisabled || !tempBrandName) return false

    const competingGoods = this.state.competingGoods

    const has = competingGoods.find((item) => {
      return item.value === tempBrandName
    })

    // 避免添加重复数据
    if (has) return false 

    this.setState({
      btnDisabled: false
    })
    this.getIndustryList(tempBrandName, res => {
      competingGoods.push({
        value: tempBrandName,
        industry: res || []
      })
      this.setState({
        competingGoods,
        btnDisabled: true,
        tempBrandName: '',
        industryList: this.getIndustryIntersection([tempIndustry].concat(competingGoods))
      })
      
    })
  }

  /**
   * 删除指定竞品
   * @param {*} index
   * @memberof SetPage
   */
  delCompetingGoods (index) {
    let {competingGoods, tempIndustry} = this.state;
    competingGoods.splice(index,1);
    this.setState({
      competingGoods,
      industryList: this.getIndustryIntersection([tempIndustry].concat(competingGoods))
    })
  }

  /**
   * 切换属性值
   * @param {*} name
   * @param {*} bl
   * @memberof SetPage
   */
  toggleProp (name, bl) {
    this.setState({
      [name]: bl
    });
  }

  /**
   * 设置品牌名
   * @memberof SetPage
   */
  setBrand = (name) => {
    this.setState({
      brand: name
    })

    this.getIndustryList(name, res => {
      this.setState({
        tempIndustry: {
          value: name,
          industry: res || []
        }
      })
    })
  }

  /**
   * 获取行业列表
   * @memberof SetPage
   */
  getIndustryList = (name, fn) => {
    getBrandIndustry({
      brandName: name
    })
      .then(res => {
        typeof fn === 'function' && fn(res)
      })
  }

  /**
   * 获取行业交集
   *
   * @memberof SetPage
   */
  getIndustryIntersection = (list) => {
    const competingGoods = list
    if (competingGoods.length === 1) {
      return competingGoods[0].industry
    } else if (competingGoods.length > 1) {
      const first = competingGoods[0].industry
      const after = competingGoods.slice(1).map(item => item.industry)
      let result = []
      first.forEach(ele => {
        let status = true
        after.forEach(item => {
          if (item.indexOf(ele) < 0) return status = false
        })
        if (status) result.push(ele)
      })
      return result
    }
    return []
  }

  render () {
    const {tempBrandName, competingGoods, isCustom, brand, beginTime, endTime, firstPage, industryList, industry} = this.state

    return (
      <div>
        <h1>设置自动化导出条件</h1>

        <div className={s.formWrapper}>
          <div>
            <label className={s.formTitle}>品牌名</label>
            <BrandInput className={s.input} value={brand} onChange={this.setBrand} />
          </div>

          <div>
            <label className={s.formTitle}>开始时间</label>
            <TimeInput className={s.input} value={beginTime} onChange={val => this.toggleProp('beginTime', val)} />
          </div>
          <div>
            <label className={s.formTitle}>结束时间</label>
            <TimeInput className={s.input} value={endTime} onChange={val => this.toggleProp('endTime', val)} />
          </div>
          <div>
            <label className={s.formTitle}>是否自定义竞品</label>
            <div>
              <label>
                <input type="radio" name="isCustom" value="0" checked={isCustom==='0'} onChange={e => this.toggleProp('isCustom', e.target.value)} />否
              </label>
              <label>
                <input type="radio" name="isCustom" value="1" checked={isCustom==='1'} onChange={e => this.toggleProp('isCustom', e.target.value)} />是
              </label>
            </div>
          </div>




          {isCustom === '1' &&
          <div style={{flexWrap: 'wrap'}}>
            
            <label className={s.formTitle}>竞品列表：</label>
            {competingGoods.map((item, index) => 
              <div className={s.tagWrapper} key={index}>
                {item.value}
                <span className={s.close} onClick={() => this.delCompetingGoods(index)}>X</span>
              </div>
            )}
            
            {competingGoods.length < 10 && 
              <div style={{display: 'flex'}}>
                {/* <BrandSelect items={items} doBattle={this.doBrandIndustryBattle} autoComplete={this.state.brandComList}/> */}
                <BrandInput className={s.input} value={tempBrandName} onChange={val => this.toggleProp('tempBrandName', val)} />
                <input type="button" className={s.btn} value="添加" onClick={this.addCompetingGoods} />
              </div>
            }
          </div>
          }

          {isCustom === '1' &&
          <div style={{flexWrap: 'wrap'}}>
            
            <label className={s.formTitle}>行业：</label>

            <select className={s.input} value={industry} onChange={e => this.toggleProp('industry', e.target.value)}>
              <option value="">请选择行业...</option>
              {industryList.map((item, index) => <option value={item} key={index}>{item}</option>)}
            </select>
          </div>
          }


          <div>
            <label className={s.formTitle}></label>
            <Link to={firstPage} className={s.setButton} onClick={this.setPage}>提交</Link>
          </div>

          <hr/>

          <div style={{display: 'block'}}>
            {/*     const {brand, industry, beginTime, endTime, competingGoods, isCustom} = this.state;
 */}
            <h2>当前查询条件</h2>
            <p>品牌名：{brand}</p>
            <p>时间：{beginTime} - {endTime}</p>
            <p>是否自定义竞品: {isCustom === '1' ? '是' : '否'}</p>
            {isCustom === '1' && 
              <div>
                <p>竞品列表：{competingGoods.map(item => item.value).join(',')}</p>
                <p>行业: {(industry !== undefined && !!industry) ? industry : ''}</p>
              </div>
            }
          </div>

        </div>
      </div>
    );
  }
};

export default withStyles(s)(SetPage)



// WEBPACK FOOTER //
// src/routes/exportPDF/setPage/setPage.js